/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages

                <!-- script-for-menu -->

                $("span.menu").click(function () {
                    $(".custom-menu ul").slideToggle("slow", function () {
                    });
                });

                $('a[href="#search"]').on('click', function (event) {
                    event.preventDefault();
                    $('#search').addClass('open');
                    $('#search > form > input[type="search"]').focus();
                });

                $('#search, #search button.close').on('click keyup', function (event) {
                    if (event.target == this || event.target.className == 'close' || event.keyCode == 27) {
                        $(this).removeClass('open');
                    }
                });

                new WOW().init();



            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }

        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
                $('.homeSlide').slick();

                $('/*#slider3,*/ #slider2').slick({autoplay: true});

                $('#nosotros').slick({
                    autoplay: true,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true,
                    arrows: true,
                    infinite: true,
                    responsive: [
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: false
                            }
                        }
                    ]
                });



            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.



/*
jQuery(window).scroll(function () {

    var footer = jQuery('.footer1').offset().top;
    var windowH = jQuery(window).scrollTop();
    var sidebarT = jQuery('.sidebarafix').offset().top;
    var sidebarH = jQuery('.sidebarafix').height();
    var docH = jQuery(document).height();
    var sidebarPos = sidebarT + sidebarH;

    if (sidebarPos > footer) {
        jQuery(".sidebarafix")
            .removeClass("affix")
            .removeData("bs.affix");
        }

});
*/
